module.exports = __webpack_public_path__ + "img/status-wallet.3639265e.png";